import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
} from '@material-ui/core';

class ActionListItem extends Component {
  render() {
    const {
      primaryText,
      secondaryText,
      secondaryAction
    } = this.props;
    return (
      <ListItem>
        <ListItemText
          primary={primaryText}
          secondary={secondaryText}
        />
        <ListItemSecondaryAction>
          {secondaryAction}
        </ListItemSecondaryAction>
      </ListItem>
    );
  }
}

ActionListItem.defaultProps = {
  secondaryText: null,
}

ActionListItem.propTypes = {
  primaryText: PropTypes.string.isRequired,
  secondaryText: PropTypes.string,
  secondaryAction: PropTypes.node.isRequired,
}

export default ActionListItem;
